<template>
    <Link :href="href" v-bind="$attrs" class="focus:shadow-outline-gray duration-50 group relative inline-flex items-center place-content-center px-6 py-3 w-full text-white text-sm font-semibold tracking-wide border border-transparent rounded-md focus:outline-none uppercase transition ease-in-out">
        <slot />
    </Link>
</template>

<script>
export default {
    props: {
        href: {
            required: true,
            type: String,
        },
    },
}
</script>
